// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"324b5235","377":"3301c23e","553":"beba0225","800":"fa41b76a"}[chunkId] + ".chunk.js";
};